module.exports = __webpack_public_path__ + "img/video-left.a1770417.png";